import { render, staticRenderFns } from "./form-description.vue?vue&type=template&id=b5525c2a&scoped=true"
import script from "./form-description.vue?vue&type=script&lang=js"
export * from "./form-description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5525c2a",
  null
  
)

export default component.exports